/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues, typeFirst } from '../runtime';
import type { RtSystemScopeDto } from './RtSystemScopeDto';
import {
    RtSystemScopeDtoFromJSON,
    RtSystemScopeDtoFromJSONTyped,
    RtSystemScopeDtoToJSON,
} from './RtSystemScopeDto';

/**
 * 
 * @export
 * @interface TypesScopeDto
 */
export interface TypesScopeDto {
    /**
     * 
     * @type {string}
     * @memberof TypesScopeDto
     */
    id: string;
    /**
     * 
     * @type {Array<RtSystemScopeDto>}
     * @memberof TypesScopeDto
     */
    systemScopes?: Array<RtSystemScopeDto> | null;
    /**
     * 
     * @type {string}
     * @memberof TypesScopeDto
     */
    $type?: TypesScopeDtoTypeEnum;
}


/**
 * @export
 */
export const TypesScopeDtoTypeEnum = {
    PtwPtw100AppZeroApplicationSharedCommonDtoScopesTypesScopeDtoPtwPtw100AppZeroApplicationShared: 'Ptw.Ptw100.AppZero.Application.Shared.Common.Dto.Scopes.TypesScopeDto, Ptw.Ptw100.AppZero.Application.Shared'
} as const;
export type TypesScopeDtoTypeEnum = typeof TypesScopeDtoTypeEnum[keyof typeof TypesScopeDtoTypeEnum];


/**
 * Check if a given object implements the TypesScopeDto interface.
 */
export function instanceOfTypesScopeDto(value?: unknown): value is TypesScopeDto {
    return !!value && typeof value === 'object' && "$type" in value && value.$type === Object.values(TypesScopeDtoTypeEnum)[0];
}

export function TypesScopeDtoFromJSON(json: any): TypesScopeDto {
    return TypesScopeDtoFromJSONTyped(json, false);
}

export function TypesScopeDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): TypesScopeDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'systemScopes': !exists(json, 'systemScopes') ? undefined : (json['systemScopes'] === null ? null : (json['systemScopes'] as Array<any>).map(RtSystemScopeDtoFromJSON)),
        '$type': !exists(json, '$type') ? undefined : json['$type'],
    };
}

export function TypesScopeDtoToJSON(value?: TypesScopeDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return typeFirst({
        
        'id': value.id,
        'systemScopes': value.systemScopes === undefined ? undefined : (value.systemScopes === null ? null : (value.systemScopes as Array<any>).map(RtSystemScopeDtoToJSON)),
        '$type': value.$type,
    });
}

